<div class="modal-header ">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
</div>

<div class="modal-body ">
  <div class="w-100 d-flex flex-column">
    <span class="label">Release Name</span>
    <select
      id="dropdown"
      [(ngModel)]="selectedRelease"
      (change)="onSelectionChange()"
      class="custom-dropdown mb-3"
    >
      <option *ngFor="let sprint of releases" [value]="sprint.value">
        {{ sprint.label }}
      </option>
    </select>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn-accello-primary-light"
      (click)="start()"
      [disabled]="isDisabled"
    >
      Start
    </button>
  </div>
</div>
